import React, { Fragment } from 'react';
import Moment from "react-moment";
import { Box, Typography } from "@mui/material";

const InfoRow = ({ label, value, valueColor }) => (
  <Box sx={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", py: 1, borderBottom: "1px solid rgba(0,0,0,0.06)" }}>
    <Typography variant="body2" sx={{ fontWeight: 500, color: "text.secondary", flex: "0 0 45%" }}>{label}</Typography>
    <Typography variant="body2" sx={{ fontWeight: 500, color: valueColor || "text.primary", flex: "1 1 auto", textAlign: "right" }}>{value}</Typography>
  </Box>
);

const DeviceUsage = ({ deviceId, modelNumber, deviceUsage, showHeader = true }) => {
  return (
    <Fragment>
      {(deviceUsage && deviceUsage.onlineStatus) ? (
        <Box>
          {showHeader && (
            <Box sx={{ textAlign: "center", py: 2 }}>
              <Typography variant="h6" component="h3" sx={{ fontWeight: 600, mb: 0 }}>
                Device Usage Info Details
              </Typography>
            </Box>
          )}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: 3,
              py: 1,
              px: 2,
              mb: 2,
              bgcolor: "#f3f3f3",
              minHeight: 40,
            }}
          >
            <Box sx={{ display: "inline-flex", alignItems: "center" }}>
              <Typography variant="body2" component="span" sx={{ fontWeight: 500, mr: 1, color: "text.secondary" }}>Device ID:</Typography>
              <Typography variant="body2" component="span" sx={{ fontWeight: 600 }}>{deviceId}</Typography>
            </Box>
            <Box sx={{ display: "inline-flex", alignItems: "center" }}>
              <Typography variant="body2" component="span" sx={{ fontWeight: 500, mr: 1, color: "text.secondary" }}>Model Number:</Typography>
              <Typography variant="body2" component="span" sx={{ fontWeight: 600 }}>{modelNumber}</Typography>
            </Box>
          </Box>

          <Box sx={{ px: 2, pb: 2 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "primary.main", mb: 1 }}>
              Device Current State
            </Typography>
            <Box sx={{ mb: 2 }}>
              <InfoRow label="Device Current State" value={deviceUsage.ps || "-"} />
              <Box sx={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", py: 1, borderBottom: "1px solid rgba(0,0,0,0.06)" }}>
                <Typography variant="body2" sx={{ fontWeight: 500, color: "text.secondary", flex: "0 0 45%" }}>Device Status</Typography>
                <Typography variant="body2" sx={{ flex: "1 1 auto", textAlign: "right" }}>
                  <span style={{ color: deviceUsage.onlineStatus === "true" ? "#2e7d32" : "#d32f2f" }}>
                    {deviceUsage.onlineStatus === "true" ? "Online" : "Offline"}
                  </span>
                  {deviceUsage.onlineStatus !== "true" && deviceUsage.connectedTime && (
                    <Typography component="span" variant="caption" sx={{ color: "text.secondary", ml: 1, display: "inline" }}>
                      (Last Active: <Moment format="MMMM Do YYYY, h:mm:ss a" date={(deviceUsage.connectedTime.toString().length < 12) ? deviceUsage.connectedTime * 1000 : deviceUsage.connectedTime} />)
                    </Typography>
                  )}
                </Typography>
              </Box>
              <InfoRow label="Filter Dust Levels" value={deviceUsage.acdl || "-"} />
            </Box>

            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "primary.main", mb: 1 }}>
              Last Controlled Info
            </Typography>
            <Box sx={{ mb: 2 }}>
              <InfoRow label="Last Controlled By" value={deviceUsage.cnt || "-"} />
              <InfoRow label="Channel" value={deviceUsage.cnt || "-"} />
              <InfoRow label="Action" value={deviceUsage.lcmd || "-"} />
            </Box>

            <InfoRow
              label="Date and Time"
              value={deviceUsage.ts ? <Moment format="MMMM Do YYYY, h:mm:ss a" date={deviceUsage.ts * 1000} /> : "-"}
            />
          </Box>
        </Box>
      ) : (
        <Box>
          {showHeader && (
            <Box sx={{ textAlign: "center", py: 2 }}>
              <Typography variant="h6" component="h3" sx={{ fontWeight: 600, mb: 0 }}>
                Device Usage Info Details
              </Typography>
            </Box>
          )}
          <Box sx={{ p: 2 }}>
            <Box sx={{ py: 1.5, px: 2, bgcolor: "rgba(211, 47, 47, 0.08)", borderRadius: 1 }}>
              <Typography variant="body2" color="error">
                {(deviceUsage && deviceUsage.msg) && deviceUsage.msg}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </Fragment>
  );
};

export default DeviceUsage;
